(() => {
  const loaded = new Set();

  const loadScript = (src) => {
    if (loaded.has(src)) return;
    loaded.add(src);
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    document.body.appendChild(script);
  };

  const init = () => {
    document.querySelectorAll('[data-lazy-script]').forEach((element) => {
      const src = element.dataset.lazyScript;
      if (!src) return;

      const observer = new IntersectionObserver(
        (entries, currentObserver) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            loadScript(src);
            currentObserver.disconnect();
          });
        },
        { rootMargin: '300px' }
      );

      observer.observe(element);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
